import { service } from "@ember/service";
import { ajax } from "discourse/lib/ajax";
import DiscourseRoute from "discourse/routes/discourse";
import { dataExplorerAiQueriesEnabled } from "discourse/plugins/discourse-data-explorer/discourse/lib/ai-query-availability";
import { rememberedMode } from "discourse/plugins/discourse-data-explorer/discourse/lib/data-explorer-store";

export default class AdminPluginsExplorerQueriesDetails extends DiscourseRoute {
  @service siteSettings;

  queryParams = {
    autoRun: {
      as: "run",
      refreshModel: false,
    },
  };

  model(params, transition) {
    const groupPromise = ajax(
      "/admin/plugins/discourse-data-explorer/groups.json"
    );
    const schemaPromise = ajax(
      "/admin/plugins/discourse-data-explorer/schema.json",
      {
        cache: true,
      }
    );

    const data = {};
    const urlParams = transition.to.queryParams.params;
    if (urlParams) {
      data.params = urlParams;
    }
    const queryPromise = ajax(
      `/admin/plugins/discourse-data-explorer/queries/${params.query_id}`,
      { data }
    );

    return groupPromise.then((groups) => {
      let groupNames = {};
      groups.forEach((g) => {
        groupNames[g.id] = g.name;
      });
      return schemaPromise.then((schema) => {
        return queryPromise.then((queryResponse) => {
          const model = this.store.createRecord("query", queryResponse.query);
          model.set(
            "group_names",
            (model.group_ids || []).map((id) => groupNames[id])
          );
          return { model, schema, groups };
        });
      });
    });
  }

  setupController(controller, model, transition) {
    controller._teardownAi();

    const cachedResult = model.model.cached_result;
    const shouldAutoRun = !!transition.to.queryParams.run;
    const showCachedResult = !!cachedResult && !shouldAutoRun;
    const aiAvailable =
      dataExplorerAiQueriesEnabled(this.siteSettings) &&
      !model.model.is_default;
    const defaultMode = aiAvailable ? (rememberedMode() ?? "ai") : "manual";

    controller.setProperties({
      ...model,
      results: showCachedResult ? cachedResult : null,
      showResults: showCachedResult,
      isCachedResult: showCachedResult,
      shouldAutoRun,
      mode: defaultMode,
      aiPrompt: "",
      lastGeneratedPrompt: null,
    });
    controller.snapshotPristine();
    controller.initView();
  }

  resetController(controller, isExiting) {
    if (isExiting) {
      controller._teardownAi();
      controller.releasePanes();
    }
  }
}
